export const customerServiceConversations = [
  { id: "c1", customer: "La Vista", contact: "邵家瑜", status: "處理中", preview: "Do you have Hibiki 21...", unread: 0, priority: "normal", tags: ["已指派"], language: "en" },
  { id: "c2", customer: "サ・リッツ・カルトンホテル", contact: "潘志豪", status: "詢問中", preview: "VIPナイトのご注文、予...", unread: 1, priority: "high", tags: ["未指派"], language: "ja" },
  { id: "c3", customer: "大同會所", contact: "鄭家瑜", status: "處理中", preview: "Sommelier 教育...", unread: 2, priority: "normal", tags: ["已指派", "會員客"], language: "zh" },
  { id: "c4", customer: "신세계면세점", contact: "王正宏", status: "詢問中", preview: "이번 물품이 아직 도착...", unread: 0, priority: "normal", tags: ["未指派"], language: "ko" },
  { id: "c5", customer: "株式会社テルオークラ東京", contact: "倪立群", status: "處理中", preview: "シャンパンナイトのご発注...", unread: 0, priority: "normal", tags: ["已指派"], language: "ja" },
  { id: "c6", customer: "中和囍宴會館", contact: "吳承翰", status: "處理中", preview: "Laurent-Perr...", unread: 0, priority: "low", tags: ["已指派", "婚宴客"], language: "zh" },
  { id: "c7", customer: "凱昇 Resort", contact: "林雅婷", status: "處理中", preview: "Client dinner for 300...", unread: 0, priority: "high", tags: ["已指派", "團體訂單"], language: "en" },
  { id: "c8", customer: "Casa Hotel", contact: "李建良", status: "詢問中", preview: "Weekend 100 guests...", unread: 0, priority: "normal", tags: ["未指派"], language: "en" },
  { id: "c9", customer: "株式会社立高食品", contact: "陳招瑄", status: "處理中", preview: "出荷証明書の手続きは？", unread: 1, priority: "normal", tags: ["已指派"], language: "ja" },
  { id: "c10", customer: "凱創控股", contact: "陳冠宇", status: "詢問中", preview: "你好，我們公司想找酒商合...", unread: 3, priority: "normal", tags: ["未指派"], language: "zh" },
  { id: "c11", customer: "Apollo 酒坊", contact: "周宜珊", status: "處理中", preview: "Any Romanee Conti...", unread: 2, priority: "high", tags: ["已指派"], language: "en" },
  { id: "c12", customer: "晶華酒店", contact: "張雅婷", status: "處理中", preview: "訂單 ORD-1042 物流...", unread: 0, priority: "normal", tags: ["已指派", "五星飯店"], language: "zh" },
  { id: "c13", customer: "君悅酒店", contact: "李志明", status: "處理中", preview: "Chateau Margaux 2015 庫存...", unread: 0, priority: "normal", tags: ["已指派"], language: "zh" },
  { id: "c14", customer: "台北W飯店", contact: "林思涵", status: "等待回覆", preview: "VIP 包廂的酒單確認...", unread: 3, priority: "high", tags: ["等待客戶"], language: "zh" },
  { id: "c15", customer: "香格里拉酒店", contact: "陳大衛", status: "已解決", preview: "感謝協助，已收到發票", unread: 0, priority: "low", tags: ["已結案"], language: "zh" },
  { id: "c16", customer: "喜來登酒店", contact: "王美玲", status: "處理中", preview: "訂單 ORD-1021 發票...", unread: 0, priority: "normal", tags: ["已指派"], language: "zh" },
  { id: "c17", customer: "圓山大飯店", contact: "趙天宇", status: "等待回覆", preview: "婚宴用酒報價詢問", unread: 1, priority: "high", tags: ["等待客戶", "婚宴客"], language: "zh" },
  { id: "c18", customer: "老爺酒店", contact: "黃雅芳", status: "已關閉", preview: "問題已解決，謝謝", unread: 0, priority: "low", tags: ["已結案"], language: "zh" },
  { id: "c19", customer: "寒舍艾美", contact: "鄭子軒", status: "詢問中", preview: "請問有沒有 Screaming...", unread: 0, priority: "normal", tags: ["已指派"], language: "zh" },
  { id: "c20", customer: "誠品行旅", contact: "謝佳欣", status: "處理中", preview: "文化活動用酒詢價", unread: 0, priority: "normal", tags: ["已指派"], language: "zh" },
  { id: "c21", customer: "亞都麗緻", contact: "劉建宏", status: "詢問中", preview: "私人酒窖佈置諮詢", unread: 0, priority: "normal", tags: ["未指派"], language: "zh" },
  { id: "c22", customer: "台北文華東方", contact: "吳佩珊", status: "等待回覆", preview: "VIP 客戶指定酒款...", unread: 2, priority: "high", tags: ["等待客戶", "VIP客"], language: "zh" },
  { id: "c23", customer: "遠東飯店", contact: "林家豪", status: "處理中", preview: "訂單 ORD-1018 確認...", unread: 0, priority: "normal", tags: ["已指派"], language: "zh" },
  { id: "c24", customer: "大倉久和", contact: "張芷琳", status: "已解決", preview: "配送手配ありがとうござい...", unread: 0, priority: "low", tags: ["已結案"], language: "ja" },
  { id: "c25", customer: "國泰萬怡酒店", contact: "王志豪", status: "詢問中", preview: "商務宴請用酒推薦", unread: 0, priority: "normal", tags: ["未指派"], language: "zh" },
];

// 各語言的多組對話腳本（每組 15 條，不同客戶隨機分配不同腳本）
// 每組的長短分布、語氣、話題都不同，避免所有客戶看起來一樣

const ZH_SCRIPT_1: string[] = [
  "你好。",
  "您好！請問有什麼可以為您服務的？",
  "我們下週有一場 VIP 晚宴，需要選幾款合適的酒，預算大概每人三千，人數大約五十人，希望有紅酒和白酒各兩款。",
  "好的。",
  "收到。",
  "了解，那我推薦這幾款：Chateau Margaux、Opus One 和 Sassicaia，另外白酒可以考慮 Montrachet 和 Puligny-Montrachet。",
  "聽起來不錯，可以先給我看報價單嗎？",
  "沒問題，我馬上整理給您。",
  "另外請問有提供品酒服務嗎？我們這邊有一些賓客對酒比較陌生，可能需要專人在場介紹每款酒的產區、風味和搭配建議，這樣晚宴體驗會更好。",
  "有的。",
  "太好了。",
  "請問需要什麼時候確認呢？因為下週二就要開始佈置場地了。",
  "這個週五前可以嗎？",
  "可以的，我盡快處理，報價單會在今天下班前寄給您。",
  "好的。",
];

const ZH_SCRIPT_2: string[] = [
  "早安，我想訂一批波爾多紅酒。",
  "早安！請問需要什麼年份和數量呢？",
  "2015 年份的，先訂兩箱。我們會所這個月有幾場商務宴請，客人指定要波爾多產區的。",
  "2015 是個好年份。",
  "請問單價？",
  "每瓶 NT$8,500，兩箱共 24 瓶，總計 NT$204,000。",
  "價格可以談嗎？",
  "量大的話可以申請折扣。",
  "我們每個月大概固定會訂 4-6 箱，長期合作有優惠嗎？",
  "可以的，我幫您申請會員價。",
  "那先試訂這一批。",
  "沒問題。",
  "大概多久可以到貨？",
  "現貨，下單後三個工作天內送達。",
  "太好了，請安排。",
  "謝謝您的訂購。",
];

const ZH_SCRIPT_3: string[] = [
  "你好，我們是寒舍艾美，想詢問婚宴用酒。",
  "您好！婚宴預計幾桌呢？",
  "三十桌，大約三百人。需要紅酒和氣泡酒。",
  "了解。",
  "有推薦的嗎？",
  "紅酒可以考慮 Chateau Lynch-Bages 或 Caymus，氣泡酒推薦 Dom Perignon 或 Veuve Clicquot。",
  "預算方面呢？",
  "整體酒水預算大概在 NT$180,000 左右。",
  "這樣的話可以搭配中端紅酒 + 高階香檳組合。",
  "具體怎麼配？",
  "每桌一瓶紅酒 + 兩瓶氣泡酒，開席前再加一瓶迎賓氣泡酒。",
  "聽起來很完整。",
  "另外我們可以派侍酒師到場服務。",
  "這個很需要！",
  "費用另外計，但會給您優惠價。",
  "好的，請給我完整報價。",
];

const ZH_SCRIPT_4: string[] = [
  "請問這款酒有沒有現貨？",
  "有的，請問您需要多少數量？",
  "一箱就好，想先試試看。",
  "好的，這款是我們的熱銷品。",
  "運費怎麼算？",
  "台北市區免運，外縣市 NT$300。",
  "我在台中。",
  "那運費 NT$300。",
  "可以貨到付款嗎？",
  "可以，另外也接受轉帳和信用卡。",
  "好，我選貨到付款。",
  "沒問題。",
  "多久會到？",
  "明天出貨，後天到。",
  "這麼快？",
  "我們台中有倉庫，所以很快。",
];

const ZH_SCRIPT_5: string[] = [
  "你好，我們想辦一場品酒會。",
  "您好！品酒會預計多少人參加？",
  "大概二十人，都是我們公司的高階主管。",
  "了解，建議準備五到六款酒做垂直品飲。",
  "什麼是垂直品飲？",
  "就是同一酒莊不同年份的酒，可以比較陳年差異。",
  "聽起來很專業。",
  "我們會提供品酒筆記和專業講師。",
  "費用大概多少？",
  "場地 + 酒款 + 講師，大概 NT$35,000。",
  "酒款可以指定嗎？",
  "當然可以，我們會根據您的預算和偏好來規劃酒單。",
  "那就麻煩你們了。",
  "請問希望什麼時候舉辦？",
  "下個月底，28 號左右。",
  "我來查一下檔期。",
  "謝謝。",
];

const ZH_SCRIPT_6: string[] = [
  "你好，請問你們有代理勃根地酒嗎？",
  "有的，我們有數個勃根地酒莊的代理權。",
  "我想找幾瓶 Premier Cru 等級的。",
  "請問預算和年份有偏好吗？",
  "單價大概 NT$4,000-6,000，2018 或 2019 年份都可以。",
  "這樣的話可以推薦 Chambolle-Musigny 和 Gevrey-Chambertin 的幾個園區。",
  "聽起來不錯，目前有現貨嗎？",
  "這兩款現貨各剩下不到一箱。",
  "那先各訂三瓶。",
  "沒問題。",
  "請問有試飲過的話可以換嗎？",
  "開瓶後不接受退換，但若有品質問題可以協助。",
  "了解。",
  "我幫您保留，今天內付款即可。",
  "好的，馬上轉帳。",
];

const ZH_SCRIPT_7: string[] = [
  "你好，中秋節快到了，我們公司想訂製一批禮盒送客戶。",
  "您好！中秋禮盒是我們的熱門項目，請問大概需要多少份？",
  "大約八十份，預算每份 NT$2,500 左右。",
  "這個預算可以搭配一支紅酒 + 兩罐精選茶葉 + 手工餅乾組合。",
  "有沒有更高階一點的選項？",
  "可以升級成單一園區紅酒 + 頂級茶葉 + 松露餅乾，每份 NT$3,800。",
  "這個好，就選這個。",
  "禮盒外觀可以客製化嗎？",
  "可以，我們有設計師可以根據貴公司 VI 設計專屬包裝。",
  "設計費另計嗎？",
  "八十份以上免設計費。",
  "太好了。",
  "大概什麼時候需要交貨？",
  "九月十號前要全部送到。",
  "沒問題，我們會安排分批出貨。",
  "那就麻煩你們了。",
];

const ZH_SCRIPT_8: string[] = [
  "你好，我上週訂的酒有問題。",
  "您好，請問是什麼問題呢？",
  "其中一瓶瓶塞凸起，看起來像是變質了。",
  "非常抱歉，這種情況我們會立刻處理。",
  "可以換貨嗎？",
  "當然可以，請問方便拍照給我們確認嗎？",
  "照片已經傳了。",
  "收到，這確實是品質問題。",
  "多久可以換好？",
  "明天安排換貨，運費我們承擔。",
  "好。",
  "另外我們會補寄一瓶同年份的作為補償。",
  "這樣可以。",
  "謝謝您的體諒。",
  "沒問題。",
];

const ZH_SCRIPT_9: string[] = [
  "你好，我們酒莊下個月有新品發表會，想邀請貴公司參加。",
  "您好！請問是哪個酒莊呢？",
  "法國隆河產區的，這次發表的是 2020 年份的 GSM 混釀。",
  "聽起來很有意思，請問時間和地點？",
  "八月十五號，在台北晶華酒店三樓宴會廳。",
  "那天我們剛好有安排，但應該可以調整。",
  "當天會有釀酒師親自到場介紹。",
  "太好了，我們一定派採購主管參加。",
  "需要幫您預留座位嗎？",
  "請留兩個位子。",
  "沒問題。",
  "有試飲的酒款嗎？",
  "會有全系列六款酒開瓶試飲。",
  "非常期待。",
  "到時見。",
];

const ZH_SCRIPT_10: string[] = [
  "你好，我們公司想做一批客製化酒標的酒當周年禮品。",
  "您好！客製酒標是我們的專項服務，請問數量？",
  "大概一百瓶，紅酒即可。",
  "酒標設計有想法了嗎？",
  "有，我們設計部已經做好稿了。",
  "那很好，請提供 AI 或 PDF 檔，我們直接送印。",
  "印刷要多久？",
  "酒標印刷約五個工作天，貼標和包裝再加三天。",
  "趕得上下個月五號嗎？",
  "沒問題，時間充裕。",
  "酒款有推薦嗎？",
  "一百瓶可以選 Cotes du Rhone 等級，性價比很高。",
  "單價多少？",
  "含客製酒標和包裝，每瓶 NT$1,200。",
  "可以。",
  "那我們開始準備。",
];

const ZH_SCRIPT_11: string[] = [
  "你好，我們是進口商，想了解一下報關流程。",
  "您好！請問是從哪個國家進口呢？",
  "主要是法國和義大利。",
  "這兩個國家都屬於歐盟產區，報關文件要求類似。",
  "需要準備哪些文件？",
  "原產地證明、衛生證書、成分分析報告、酒標樣張，還有進口許可。",
  "這些文件酒莊通常都能提供吧？",
  "大部分可以，但成分分析報告有時需要額外申請。",
  "申請要多久？",
  "通常兩到三週，建議提前準備。",
  "稅率方面呢？",
  "葡萄酒進口關稅是完稅價格的 10%，再加上營業稅。",
  "了解。",
  "我們可以協助處理全套報關流程。",
  "那先請你們報個價。",
  "沒問題，我整理一下服務項目和費用給您。",
];

const ZH_SCRIPT_12: string[] = [
  "你好，請問你們有酒櫃租賃服務嗎？",
  "有的，我們有各種容量的專業酒櫃可供租賃。",
  "我們會所大概需要放兩百瓶左右。",
  "兩百瓶的話可以租 300L 的雙溫區酒櫃。",
  "月租多少？",
  "NT$3,500 一個月，含維護和溫度監控。",
  "溫度可以調整嗎？",
  "可以，紅酒區建議 12-16 度，白酒區 8-12 度。",
  "濕度呢？",
  "內建恆濕系統，維持 60-70%。",
  "聽起來很專業。",
  "而且我們提供定期巡檢服務。",
  "租約最短多久？",
  "三個月起租，提前解約需一個月通知。",
  "我先租半年試試。",
  "好的，我準備合約給您。",
  "謝謝。",
];

const ZH_SCRIPT_13: string[] = [
  "你好，我們集團想談年度酒水採購合約。",
  "您好！年度合約是我們的重點業務，請問預估年採購量？",
  "大概三百箱，紅酒為主，部分白酒和香檳。",
  "這個量可以給到很好的價格。",
  "目前合作價大概多少？",
  "根據酒款等級，年採三百箱可以談到 75-8 折。",
  "付款條件呢？",
  "年度合約通常月結 60 天。",
  "可以試樣嗎？",
  "當然，我們可以安排品酒會讓貴團隊試飲。",
  "什麼時候可以開始？",
  "下個月初可以簽約，酒款清單確認後兩週內首批到貨。",
  "沒問題。",
  "合約期間有價格保護嗎？",
  "一年期內鎖定價格，不受市場波動影響。",
  "這點很重要。",
  "我們會把這條寫進合約。",
];

const ZH_SCRIPT_14: string[] = [
  "你好，我們公司尾牙想用酒，想請你們推薦。",
  "您好！尾牙大概多少人？",
  "全公司大概一百五十人。",
  "這樣的話建議準備紅酒、白酒和氣泡酒各一款。",
  "預算不要太高，但要有面子。",
  "紅酒選 Cotes du Rhone Villages，白酒選 Sancerre，氣泡選 Prosecco。",
  "聽起來不錯，單價？",
  "紅酒 NT$680，白酒 NT$620，氣泡 NT$450。",
  "可以。",
  "需要搭配開瓶服務嗎？",
  "不用，我們自己有服務生。",
  "那酒款我們會提前一天送到。",
  "送到公司嗎？",
  "對，台北地區免運。",
  "好。",
  "尾牙日期是？",
  "一月二十號。",
  "記下了。",
];

const ZH_SCRIPT_15: string[] = [
  "你好，我們明年三月要參加台北國際酒展，想了解一下合作方式。",
  "您好！酒展合作我們很有經驗，請問貴公司攤位大小？",
  "預計六個攤位，大概 18 坪。",
  "這個規模不小，建議準備六到八款主打酒款。",
  "我們想主打義大利酒。",
  "很好，義大利酒在台灣市場越來越受歡迎。",
  "可以安排釀酒師到場嗎？",
  "可以，我們有幾個合作的義大利酒莊願意派釀酒師來。",
  "機票和住宿誰負責？",
  "通常酒莊負責機票，住宿由參展方安排。",
  "了解。",
  "每天試飲酒量怎麼抓？",
  "六天展期，每天開六瓶，總共三十六瓶。",
  "需要備多少庫存？",
  "建議備 1.5 倍，也就是五十四瓶。",
  "可以。",
  "那我們開始規劃酒單和物流。",
  "麻煩你們了。",
];

const JA_SCRIPT_1: string[] = [
  "こんにちは。",
  "はい、どのようなご用件でしょうか？",
  "来週VIPディナーがあるので、適したワインを選びたいです。約50名で、お一人様NT$3,000程度、赤白各2本ずつご提案いただけますでしょうか。",
  "かしこまりました。",
  "承知しました。",
  "シャトー・マルゴー、オーパスワン、サッシカイアをお勧めします。白ワインではモンラッシェとプリニー・モンラッシェが良いかと思います。",
  "良さそうですね。見積書をいただけますか？",
  "はい、すぐにご用意いたします。",
  "テイスティングサービスはありますか？一部のゲストはワインに詳しくないので、産地や風味、ペアリングのご説明を専任スタッフにお願いしたいのですが。",
  "ございます。",
  "素晴らしいです。",
  "いつまでにご確認いただけますか？来週火曜日には会場の準備を始めますので。",
  "今週の金曜日までにお願いできますか？",
  "承知しました、早急に対応いたします。本日中にお見積りをメールでお送りします。",
  "よろしくお願いします。",
];

const JA_SCRIPT_2: string[] = [
  "ボルドーの赤ワインを注文したいのですが。",
  "はい、どの年物と数量をご希望ですか？",
  "2015年物を2ケースほど。今月数回ビジネスディナーがあり、ゲストがボルドーをご希望されています。",
  "2015年は素晴らしい年です。",
  "1本の単価を教えてください。",
  "1本NT$8,500、2ケースで24本、合計NT$204,000です。",
  "値引きは可能でしょうか？",
  "大量であれば割引をご相談できます。",
  "毎月4〜6ケース程度の定期注文を検討しています。",
  "かしこまりました、会員価格をご提案いたします。",
  "ではまず今回の分でお願いします。",
  "承知しました。",
  "納期はどのくらいですか？",
  "在庫ありですので、ご注文後3営業日以内にお届けします。",
  "素晴らしい、お願いします。",
  "ご注文ありがとうございます。",
];

const JA_SCRIPT_3: string[] = [
  "結婚式の披露宴用ワインを相談したいです。",
  "かしこまりました。披露宴は何卓ご予定ですか？",
  "30卓、約300名様です。赤ワインとスパークリングをご用意したいです。",
  "承知しました。",
  "おすすめはありますか？",
  "赤ワインはシャトー・リンチ・バージュやケイマス、スパークリングはドン・ペリニヨンやヴーヴ・クリコが人気です。",
  "予算はどのくらいでしょうか？",
  "飲料全体でNT$180,000程度で考えています。",
  "であれば、ミドルレンジの赤ワイン＋プレミアムシャンパンの組み合わせが良いかと思います。",
  "具体的にどういった組み合わせですか？",
  "卓ごとに赤ワイン1本＋スパークリング2本、ご挨拶時にもう1本スパークリングを追加という構成です。",
  "とても魅力的ですね。",
  "また、ソムリエの派遣も承っております。",
  "それはぜひお願いしたいです！",
  "別途費用になりますが、優待価格でご案内いたします。",
  "かしこまりました、お見積りをお願いします。",
];

const JA_SCRIPT_4: string[] = [
  "このワインは在庫がありますか？",
  "はい、ございます。何本ご希望ですか？",
  "1箱で試してみたいです。",
  "かしこまりました、当店人気商品です。",
  "送料はいくらですか？",
  "台北市内は送料無料、それ以外はNT$300です。",
  "私は台中におります。",
  "であれば送料NT$300です。",
  "代金引換は可能ですか？",
  "可能です。振込とクレジットカードも承っております。",
  "代金引換でお願いします。",
  "承知しました。",
  "到着までどのくらいかかりますか？",
  "明日発送で、明後日にお届けします。",
  "そんなに早いのですか？",
  "台中に倉庫がございますので、迅速にお届けできます。",
];

const JA_SCRIPT_5: string[] = [
  "ワインテイスティングイベントを開催したいのですが。",
  "かしこまりました。参加予定者は何名様でしょうか？",
  "約20名です。うちの会社のエグゼクティブメンバーです。",
  "承知しました。5〜6種類のワインでヴァーティカルテイスティングがおすすめです。",
  "ヴァーティカルテイスティングとは？",
  "同じワイナリーで異なる年物のワインを比較し、熟成の違いを楽しむ形式です。",
  "とても興味深いですね。",
  "テイスティングノートと専門講師もご用意いたします。",
  "費用はどのくらいですか？",
  "会場＋ワイン＋講師で、NT$35,000程度です。",
  "ワインは指定できますか？",
  "もちろんです。ご予算と好みに応じてワインリストをご提案いたします。",
  "ではお願いします。",
  "開催希望日はいつでしょうか？",
  "来月末、28日ごろを考えています。",
  "スケジュールを確認いたします。",
  "よろしくお願いします。",
];

const JA_SCRIPT_6: string[] = [
  "ブルゴーニュのワインは取り扱っていますか？",
  "はい、複数のブルゴーニュ生産者の代理店です。",
  "プルミエ・クリュを探しているのですが。",
  "ご予算とご希望の年物はありますか？",
  "1本NT$4,000〜6,000程度、2018年か2019年で。",
  "であれば、シャンボール・ミュジニーとジュヴレ・シャンベルタンの区画をお勧めします。",
  "素敵ですね。在庫はありますか？",
  "どちらも残り1ケース未満です。",
  "では各3本ずつお願いします。",
  "かしこまりました。",
  "試飲後、気に入らなければ交換できますか？",
  "開封後の交換はできませんが、品質問題の場合は対応いたします。",
  "了解しました。",
  "お留めしておきますので、本日中にお振込みください。",
  "はい、すぐに振込みます。",
];

const JA_SCRIPT_7: string[] = [
  "こんにちは、中秋節に向けてギフトセットのオーダーを検討しています。",
  "こんにちは！中秋ギフトは人気商品ですが、何セットほどお考えですか？",
  "約80セット、1セットNT$2,500程度の予算です。",
  "この予算であれば、赤ワイン1本＋厳選茶葉2缶＋手作りクッキーのセットが可能です。",
  "もう少し高級感のあるものはありますか？",
  "単一畑ワイン＋高級茶葉＋トリュフクッキーにアップグレードできます。1セットNT$3,800です。",
  "これにします。",
  "ボックスのデザインはカスタマイズできますか？",
  "はい、デザイナーが御社のVIに合わせて専用パッケージをデザインします。",
  "デザイン費は別途ですか？",
  "80セット以上であればデザイン費無料です。",
  "素晴らしい。",
  "納期はいつまでに必要ですか？",
  "9月10日までに全て配送していただきたいです。",
  "かしこまりました、分割配送で対応いたします。",
  "よろしくお願いします。",
];

const JA_SCRIPT_8: string[] = [
  "こんにちは、先週注文したワインに問題がありまして。",
  "こんにちは、どのような問題でしょうか？",
  "1本のコルクが浮いていて、変質しているようです。",
  "大変申し訳ございません。すぐに対応いたします。",
  "交換は可能でしょうか？",
  "もちろんです。お写真を送っていただけますか？",
  "写真を送りました。",
  "確認いたしました。確かに品質問題ですね。",
  "交換までどのくらいかかりますか？",
  "明日に交換品を発送し、送料はこちらで負担します。",
  "わかりました。",
  "また、同年物のワインを1本お詫びとしてお送りします。",
  "それで結構です。",
  "ご理解いただきありがとうございます。",
  "はい。",
];

const JA_SCRIPT_9: string[] = [
  "こんにちは、来月に新商品発表会を開催しますので、御社にご招待したいのですが。",
  "こんにちは！どちらの生産者でしょうか？",
  "フランスのローヌ産区で、今回は2020年物のGSMブレンドです。",
  "興味深いですね。日程と会場を教えてください。",
  "8月15日、台北のリージェントホテル3階の宴会場です。",
  "その日は予定がありますが、調整できるかと思います。",
  "当日は醸造家本人が説明に来られます。",
  "素晴らしいです。当社の購責任者を出席させます。",
  "お席をご用意しましょうか？",
  "2席お願いします。",
  "かしこまりました。",
  "試飲のワインはありますか？",
  "全シリーズ6種類の試飲をご用意しております。",
  "楽しみにしております。",
  "では当日お会いしましょう。",
];

const JA_SCRIPT_10: string[] = [
  "こんにちは、当社の記念品としてカスタムラベルのワインを作りたいのですが。",
  "こんにちは！カスタムラベルは当社の得意分野です。数量は？",
  "約100本、赤ワインでお願いします。",
  "ラベルデザインは既に決まっていますか？",
  "はい、デザイン部でデータを作成済みです。",
  "それは早いですね。AIかPDFデータをいただければ印刷に回します。",
  "印刷にどのくらいかかりますか？",
  "ラベル印刷は5営業日、貼り付けと梱包はさらに3日です。",
  "来月5日までに間に合いますか？",
  "余裕を持って対応可能です。",
  "お勧めのワインはありますか？",
  "100本であればコート・デュ・ローヌがコスパが良いです。",
  "単価は？",
  "カスタムラベルと梱包込みで1本NT$1,200です。",
  "了解です。",
  "では準備を開始いたします。",
];

const JA_SCRIPT_11: string[] = [
  "こんにちは、輸入業者ですが、税関手続きについて相談したいです。",
  "こんにちは！どの国からの輸入でしょうか？",
  "主にフランスとイタリアです。",
  "どちらもEU産区ですので、税関書類の要件は類似しています。",
  "どのような書類が必要ですか？",
  "原産地証明書、衛生証明書、成分分析報告書、ラベル見本、輸入許可証です。",
  "これらは生産者側で揃いますか？",
  "ほとんどは揃いますが、成分分析報告書は別途申請が必要な場合があります。",
  "申請にはどのくらいかかりますか？",
  "通常2〜3週間ですので、事前に準備することをお勧めします。",
  "税率はどのくらいですか？",
  "ワインの輸入関税は課税価格の10%に営業税が加算されます。",
  "了解しました。",
  "税関手続きの全プロセスをサポートできます。",
  "では費用を見積もっていただけますか。",
  "かしこまりました、サービス項目と費用をまとめます。",
];

const JA_SCRIPT_12: string[] = [
  "こんにちは、ワインセラーのレンタルサービスはありますか？",
  "はい、各種容量の業務用セラーをレンタルしております。",
  "当クラブは200本程度収納したいのですが。",
  "200本であれば300Lのデュアルゾーンセラーが適しています。",
  "月額料金は？",
  "月額NT$3,500で、メンテナンスと温度監視込みです。",
  "温度調整は可能ですか？",
  "はい、赤ワインゾーンは12-16度、白ワインゾーンは8-12度が推奨です。",
  "湿度は？",
  "内蔵の恒湿システムで60-70%を維持します。",
  "非常に専門的ですね。",
  "定期点検サービスも付帯しております。",
  "最短契約期間は？",
  "3ヶ月から、中途解約は1ヶ月前のご連絡が必要です。",
  "まず半年でお願いします。",
  "かしこまりました、契約書をご用意します。",
  "ありがとうございます。",
];

const JA_SCRIPT_13: string[] = [
  "こんにちは、当グループで年間の酒水購買契約を検討しています。",
  "こんにちは！年間契約は当社の重点事業です。年間購入予定量は？",
  "約300ケース、主に赤ワインで、一部白ワインとシャンパンです。",
  "この量であれば非常に良い価格が出せます。",
  "現在の協力価格はどのくらいですか？",
  "ワインの等級によりますが、年間300ケースで75〜8割引が可能です。",
  "支払い条件は？",
  "年間契約では通常、月締め60日払いです。",
  "試飲はできますか？",
  "もちろんです。テイスティングイベントをご用意できます。",
  "いつから始められますか？",
  "来月初めに契約締結、酒リスト確認後2週間以内に初回納品です。",
  "問題ありません。",
  "契約期間中の価格保護はありますか？",
  "1年間は価格をロックし、市場変動の影響を受けません。",
  "これは重要ですね。",
  "契約書に明記いたします。",
];

const JA_SCRIPT_14: string[] = [
  "こんにちは、当社の忘年会用のワインをお勧めていただきたいです。",
  "こんにちは！忘年会は何名様ですか？",
  "全社員で約150名です。",
  "であれば、赤ワイン・白ワイン・スパークリングを各1種類ご用意するのが良いかと思います。",
  "予算はあまり高くなく、でも見栄えは良くしたいです。",
  "赤ワインはコート・デュ・ローヌ・ヴィラージュ、白ワインはサンセール、スパークリングはプロセッコを。",
  "良さそうですね。単価は？",
  "赤ワインNT$680、白ワインNT$620、スパークリングNT$450です。",
  "了解です。",
  "栓抜きサービスも必要ですか？",
  "いえ、当社にスタッフがいます。",
  "であれば、前日に配送いたします。",
  "会社宛ですか？",
  "はい、台北市内は送料無料です。",
  "わかりました。",
  "忘年会の日程は？",
  "1月20日です。",
  "記録しておきます。",
];

const JA_SCRIPT_15: string[] = [
  "こんにちは、来年3月の台北国際ワインショーに出展予定で、協力について相談したいです。",
  "こんにちは！ワインショーの協力は経験豊富です。ブースの規模は？",
  "6ブースで、約18坪の予定です。",
  "それは大きいですね。メイン酒款は6〜8種類ご用意するのが良いかと思います。",
  "イタリアワインをメインにしたいです。",
  "良いですね。台湾市場ではイタリアワインが人気上昇中です。",
  "醸造家を呼べますか？",
  "はい、協力しているイタリアの生産者数社が醸造家を派遣できます。",
  "航空券と宿泊は誰が負担しますか？",
  "通常、生産者側が航空券、出展側が宿泊を手配します。",
  "了解しました。",
  "1日の試飲量はどのくらいでしょうか？",
  "6日間で、毎日6本開栓、合計36本です。",
  "どのくらいの在庫を準備すれば良いですか？",
  "1.5倍の54本をお勧めします。",
  "かしこまりました。",
  "では酒リストと物流を計画します。",
  "よろしくお願いします。",
];

const KO_SCRIPT_1: string[] = [
  "안녕하세요.",
  "안녕하세요! 무엇을 도와드릴까요?",
  "다음 주 VIP 만찬이 있어서 적합한 와인을 고르고 싶습니다. 약 50명, 1인당 NT$3,000 정도 예산이고, 레드와인과 화이트와인 각각 2종류씩 추천해 주실 수 있나요?",
  "네, 알겠습니다.",
  "네.",
  "샤토 마고, 오퍼스 원, 사시카이아를 추천드립니다. 화이트와인은 몽라셰와 풀리니 몽라셰를 고려해 보세요.",
  "좋네요. 견적서 먼저 보내주실 수 있나요?",
  "네, 바로 준비해드리겠습니다.",
  "테이스팅 서비스도 있나요? 일부 손님들은 와인을 잘 모르셔서, 전담 직원이 산지와 풍미, 페어링을 설명해 주시면 좋겠습니다.",
  "네, 있습니다.",
  "좋습니다.",
  "언제까지 확인하면 될까요? 다음 주 화요일부터 장소 준비를 시작해야 해서요.",
  "이번 주 금요일까지 가능할까요?",
  "네, 최대한 빨리 처리하겠습니다. 오늘 중으로 견적서를 메일로 보내드리겠습니다.",
  "연락 기다리겠습니다.",
];

const KO_SCRIPT_2: string[] = [
  "보르도 레드와인을 주문하고 싶습니다.",
  "네, 어떤 빈티지와 수량이 필요하신가요?",
  "2015년산 2박스요. 이번 달에 비즈니스 만찬이 여러 번 있어서 손님이 보르도를 원하셔서요.",
  "2015년은 좋은 해입니다.",
  "1병 가격이 어떻게 되나요?",
  "1병 NT$8,500, 2박스 24병 총 NT$204,000입니다.",
  "할인 가능한가요?",
  "대량이면 할인 협의 가능합니다.",
  "매달 4-6박스 정도 정기 주문을 고려하고 있어요.",
  "네, 회원가로 안내해드리겠습니다.",
  "그럼 우선 이번 분만 주문할게요.",
  "네, 바로 처리해드리겠습니다.",
  "배송은 얼마나 걸리나요?",
  "재고 있어서 주문 후 3영업일 이내 배송됩니다.",
  "정말 빠르네요!",
  "주문 감사합니다.",
];

const KO_SCRIPT_3: string[] = [
  "결혼식 피로연 와인을 상담하고 싶습니다.",
  "네, 피로연은 몇 테이블 예정이신가요?",
  "30테이블, 약 300명이요. 레드와인과 스파클링 와인이 필요합니다.",
  "알겠습니다.",
  "추천해 주실 만한 게 있나요?",
  "레드와인은 샤토 린치 바지스나 케이머스, 스파클링은 돔 페리뇽이나 뷔브 클리코가 인기입니다.",
  "예산은 어느 정도인가요?",
  "전체 음료 예산이 NT$180,000 정도입니다.",
  "그렇다면 미들레인지 레드와인 + 프리미엄 샴페인 조합이 좋을 것 같습니다.",
  "구체적으로 어떤 조합인가요?",
  "테이블당 레드와인 1병 + 스파클링 2병, 오프닝에 스파클링 1병 추가하는 구성입니다.",
  "매우 매력적이네요.",
  "또한 소믈리에 파견도 가능합니다.",
  "그건 꼭 부탁드리고 싶습니다!",
  "별도 비용이지만 우대가로 안내해드리겠습니다.",
  "네, 견적서 부탁드립니다.",
];

const KO_SCRIPT_4: string[] = [
  "이 와인 재고 있나요?",
  "네, 있습니다. 몇 병 필요하신가요?",
  "1박스로 먼저 시험해보고 싶어요.",
  "네, 당사 인기 상품입니다.",
  "배송비는 얼마인가요?",
  "타이베이 시내는 무료, 그 외는 NT$300입니다.",
  "저는 타이중에 있어요.",
  "그러면 배송비 NT$300입니다.",
  "착불 가능한가요?",
  "네, 가능합니다. 계좌이체와 신용카드도 가능합니다.",
  "착불로 해주세요.",
  "네, 알겠습니다.",
  "도착까지 얼마나 걸리나요?",
  "내일 발송해서 모레 도착합니다.",
  "그렇게 빠른가요?",
  "타이중에 창고가 있어서 빠르게 배송 가능합니다.",
];

const KO_SCRIPT_5: string[] = [
  "와인 테이스팅 행사를 개최하고 싶습니다.",
  "네, 참가 예정자는 몇 분이신가요?",
  "약 20분이요. 저희 회사 임원진입니다.",
  "알겠습니다. 5-6종류의 와인으로 버티컬 테이스팅을 추천드립니다.",
  "버티컬 테이스팅이 뭔가요?",
  "같은 와이너리의 다른 빈티지 와인을 비교하며 숙성 차이를 느끼는 형식입니다.",
  "정말 흥미롭네요.",
  "테이스팅 노트와 전문 강사도 준비해드립니다.",
  "비용은 얼마인가요?",
  "장소 + 와인 + 강사로 NT$35,000 정도입니다.",
  "와인은 지정할 수 있나요?",
  "물론입니다. 예산과 취향에 맞춰 와인 리스트를 제안해드리겠습니다.",
  "그럼 부탁드립니다.",
  "개최 희망일은 언제인가요?",
  "다음 달 말, 28일쯤 생각하고 있어요.",
  "일정 확인해드리겠습니다.",
  "감사합니다.",
];

const KO_SCRIPT_6: string[] = [
  "부르고뉴 와인도 취급하시나요?",
  "네, 여러 부르고뉴 생산자의 대리점입니다.",
  "프르미에 크뤼 등급을 찾고 있어요.",
  "예산과 선호하는 빈티지가 있으신가요?",
  "1병당 NT$4,000-6,000 정도, 2018년이나 2019년이면 됩니다.",
  "그렇다면 샹볼 뮈지니와 쥬브레 샹베르탱의 몇 구획을 추천드립니다.",
  "좋네요. 재고 있나요?",
  "두 종 모두 1박스 미만 남았습니다.",
  "그럼 각각 3병씩 주문할게요.",
  "네, 알겠습니다.",
  "시음 후 마음에 안 들면 교환 가능한가요?",
  "개봉 후 교환은 불가하지만 품질 문제는 대응 가능합니다.",
  "알겠습니다.",
  "보관해드리겠으니 오늘 중으로 입금해주세요.",
  "네, 바로 송금하겠습니다.",
];

const KO_SCRIPT_7: string[] = [
  "안녕하세요, 추석을 앞두고 기프트 세트 주문을 검토하고 있습니다.",
  "안녕하세요! 추석 기프트는 인기 상품인데, 몇 세트 정도 생각하시나요?",
  "약 80세트, 세트당 NT$2,500 정도 예산입니다.",
  "이 예산이라면 레드와인 1병 + 엄선된 차 2캔 + 수제 쿠키 세트가 가능합니다.",
  "조금 더 고급스러운 건 없나요?",
  "싱글 빈야드 레드와인 + 프리미엄 차 + 트러플 쿠키로 업그레이드 가능합니다. 세트당 NT$3,800입니다.",
  "이걸로 할게요.",
  "박스 디자인은 커스터마이징 가능한가요?",
  "네, 디자이너가 귀사 VI에 맞춰 전용 패키지를 디자인해드립니다.",
  "디자인비는 별도인가요?",
  "80세트 이상이면 디자인비 무료입니다.",
  "훌륭하네요.",
  "납기는 언제까지 필요하신가요?",
  "9월 10일까지 전부 배송되었으면 합니다.",
  "알겠습니다, 분할 배송으로 대응하겠습니다.",
  "부탁드립니다.",
];

const KO_SCRIPT_8: string[] = [
  "안녕하세요, 지난주 주문한 와인에 문제가 있어서요.",
  "안녕하세요, 어떤 문제인가요?",
  "한 병 코르크가 튀어나와 있고 변질된 것 같습니다.",
  "정말 죄송합니다. 바로 대응하겠습니다.",
  "교환 가능한가요?",
  "물론입니다. 사진을 보내주실 수 있나요?",
  "사진 보냈습니다.",
  "확인했습니다. 확실히 품질 문제네요.",
  "교환까지 얼마나 걸리나요?",
  "내일 교환품 발송하고 운송비는 저희가 부담합니다.",
  "알겠습니다.",
  "또한 사과의 의미로 동빈티지 와인 1병 추가로 보내드리겠습니다.",
  "그걸로 괜찮습니다.",
  "양해해 주셔서 감사합니다.",
  "네.",
];

const KO_SCRIPT_9: string[] = [
  "안녕하세요, 다음 달에 신제품 발표회를 개최하는데 귀사를 초대하고 싶습니다.",
  "안녕하세요! 어느 생산자신가요?",
  "프랑스 론 지역인데, 이번에는 2020년산 GSM 블렌드입니다.",
  "흥미롭네요. 일정과 장소를 알려주세요.",
  "8월 15일, 타이베이 리젠트 호텔 3층 연회장입니다.",
  "그날 일정이 있지만 조정할 수 있을 것 같습니다.",
  "당일 양조사 본인이 설명하러 오십니다.",
  "훌륭하네요. 우리 구매 책임자를 보내겠습니다.",
  "좌석을 예약해드릴까요?",
  "2석 부탁드립니다.",
  "알겠습니다.",
  "시음 와인이 있나요?",
  "전 시리즈 6종류 시음을 준비하고 있습니다.",
  "매우 기대됩니다.",
  "그럼 당일 뵙겠습니다.",
];

const KO_SCRIPT_10: string[] = [
  "안녕하세요, 회사 기념품으로 커스텀 라벨 와인을 만들고 싶습니다.",
  "안녕하세요! 커스텀 라벨은 저희 전문 분야입니다. 수량은요?",
  "약 100병, 레드와인으로 부탁드립니다.",
  "라벨 디자인은 이미 결정되었나요?",
  "네, 디자인팀에서 데이터를 작성했습니다.",
  "그러면 빠르시네요. AI나 PDF 파일을 주시면 바로 인쇄에 넘기겠습니다.",
  "인쇄는 얼마나 걸리나요?",
  "라벨 인쇄는 5영업일, 부착과 포장은 추가 3일입니다.",
  "다음 달 5일까지 가능할까요?",
  "여유 있게 대응 가능합니다.",
  "추천 와인이 있나요?",
  "100병이라면 꼿 드 뇽이 가성비가 좋습니다.",
  "단가는요?",
  "커스텀 라벨과 포장 포함해서 1병 NT$1,200입니다.",
  "알겠습니다.",
  "그럼 준비 시작하겠습니다.",
];

const KO_SCRIPT_11: string[] = [
  "안녕하세요, 수입업자인데 세관 절차에 대해 상담하고 싶습니다.",
  "안녕하세요! 어느 나라에서 수입하시나요?",
  "주로 프랑스와 이탈리아입니다.",
  "둘 다 EU 산지라서 세관 서류 요건은 비슷합니다.",
  "어떤 서류가 필요한가요?",
  "원산지 증명서, 위생 증명서, 성분 분석 보고서, 라벨 견본, 수입 허가증입니다.",
  "이건 생산자 쪽에서 다 갖춰지나요?",
  "대부분은 갖춰지지만 성분 분석 보고서는 별도 신청이 필요한 경우가 있습니다.",
  "신청은 얼마나 걸리나요?",
  "보통 2-3주니 미리 준비하시는 걸 추천드립니다.",
  "세율은 얼마인가요?",
  "와인 수입 관세는 과세 가격의 10%에 부가세가 추가됩니다.",
  "알겠습니다.",
  "세관 절차 전 과정을 지원해드릴 수 있습니다.",
  "그럼 비용 견적 부탁드립니다.",
  "알겠습니다, 서비스 항목과 비용을 정리해드리겠습니다.",
];

const KO_SCRIPT_12: string[] = [
  "안녕하세요, 와인 셀러 대여 서비스가 있나요?",
  "네, 다양한 용량의 업무용 셀러를 대여하고 있습니다.",
  "우리 클럽은 200병 정도 수납하고 싶은데요.",
  "200병이라면 300L 듀얼 존 셀러가 적합합니다.",
  "월 임대료는 얼마인가요?",
  "월 NT$3,500으로 유지보수와 온도 모니터링이 포함됩니다.",
  "온도 조절 가능한가요?",
  "네, 레드와인 존은 12-16도, 화이트와인 존은 8-12도가 권장됩니다.",
  "습도는요?",
  "내장된 항습 시스템으로 60-70%를 유지합니다.",
  "매우 전문적이네요.",
  "정기 점검 서비스도附帶되어 있습니다.",
  "최단 계약 기간은 얼마인가요?",
  "3개월부터이며 중도 해지는 1개월 전 연락이 필요합니다.",
  "일단 6개월로 해볼게요.",
  "알겠습니다, 계약서를 준비해드리겠습니다.",
  "감사합니다.",
];

const KO_SCRIPT_13: string[] = [
  "안녕하세요, 저희 그룹에서 연간 주류 구매 계약을 검토하고 있습니다.",
  "안녕하세요! 연간 계약은 저희 중점 사업입니다. 연간 구매 예정량은요?",
  "약 300박스, 주로 레드와인이고 일부 화이트와인과 샴페인입니다.",
  "이 정도 양이라면 아주 좋은 가격이 나옵니다.",
  "현재 협력 가격은 어느 정도인가요?",
  "와인 등급에 따라 다르지만 연간 300박스면 75-80% 할인이 가능합니다.",
  "대금 조건은요?",
  "연간 계약은 보통 월마감 60일입니다.",
  "시음 가능한가요?",
  "물론입니다. 테이스팅 이벤트를 준비해드릴 수 있습니다.",
  "언제부터 시작할 수 있나요?",
  "다음 달 초에 계약 체결, 주류 리스트 확인 후 2주 이내에 첫 입고입니다.",
  "문제없습니다.",
  "계약 기간 중 가격 보호가 있나요?",
  "1년간 가격을 잠그어 시장 변동의 영향을 받지 않습니다.",
  "이 점이 중요합니다.",
  "계약서에 명기해드리겠습니다.",
];

const KO_SCRIPT_14: string[] = [
  "안녕하세요, 저희 회사 송년회에 쓸 와인을 추천받고 싶습니다.",
  "안녕하세요! 송년회는 몇 분이신가요?",
  "전사원이 약 150분입니다.",
  "그렇다면 레드와인, 화이트와인, 스파클링을 각각 1종류 준비하는 게 좋습니다.",
  "예산은 너무 높지 않으면서도 체면은 서야 합니다.",
  "레드와인은 꼿 드 뇽 빌라주, 화이트는 상세르, 스파클링은 프로세꼬를 추천드립니다.",
  "좋네요, 단가는요?",
  "레드와인 NT$680, 화이트와인 NT$620, 스파클링 NT$450입니다.",
  "괜찮습니다.",
  "오프너 서비스도 필요하신가요?",
  "아니요, 저희 직원이 있습니다.",
  "그럼 전날에 배송해드리겠습니다.",
  "회사로 배송되나요?",
  "네, 타이베이 시내는 무료 배송입니다.",
  "알겠습니다.",
  "송년회 날짜는요?",
  "1월 20일입니다.",
  "기록해두겠습니다.",
];

const KO_SCRIPT_15: string[] = [
  "안녕하세요, 내년 3월 타이베이 국제 와인쇼에 출展 예정인데 협력에 대해 상담하고 싶습니다.",
  "안녕하세요! 와인쇼 협력은 경험이 풍부합니다. 부스 규모는요?",
  "6부스로, 약 18평 정도입니다.",
  "그건 크네요. 메인 주류는 6-8종류 준비하시는 게 좋습니다.",
  "이탈리아 와인을 메인으로 하고 싶습니다.",
  "좋습니다. 대만 시장에서 이탈리아 와인이 인기 상승 중입니다.",
  "양조사를 불러올 수 있나요?",
  "네, 협력하는 이탈리아 생산자 몇 곳이 양조사를 파견할 수 있습니다.",
  "항공권과 숙박은 누가 부담하나요?",
  "보통 생산자 쪽이 항공권, 출展 쪽이 숙박을 부담합니다.",
  "알겠습니다.",
  "하루 시음량은 어느 정도로 잡나요?",
  "6일간 매일 6병 개봉, 총 36병입니다.",
  "얼마나 많은 재고를 준비해야 할까요?",
  "1.5배인 54병을 추천드립니다.",
  "알겠습니다.",
  "그럼 주류 리스트와 물류를 계획하겠습니다.",
  "부탁드립니다.",
];

const EN_SCRIPT_1: string[] = [
  "Hi.",
  "Hello! How can I assist you today?",
  "We have a VIP dinner next week and need to select some suitable wines. Around 50 people, budget about NT$3,000 per person. Can you recommend two reds and two whites?",
  "Sure.",
  "Got it.",
  "I'd recommend Chateau Margaux, Opus One, and Sassicaia. For whites, Montrachet and Puligny-Montrachet would be excellent choices.",
  "Sounds great. Can you send me the quotation first?",
  "Sure, I'll prepare it right away.",
  "Also, do you offer tasting services? Some of our guests aren't familiar with wines, so we'd appreciate having a specialist explain the regions, flavor profiles, and pairing suggestions during the dinner.",
  "Yes, we do.",
  "Wonderful.",
  "When would you need confirmation? We need to start venue setup by next Tuesday.",
  "By this Friday, is that possible?",
  "Absolutely, I'll expedite it. You'll receive the quotation via email before end of business today.",
  "Thanks, looking forward to it.",
];

const EN_SCRIPT_2: string[] = [
  "Hi, I'd like to order some Bordeaux reds.",
  "Hello! What vintage and quantity are you looking for?",
  "2015 vintage, two cases. Our club has several business dinners this month and the guests specifically requested Bordeaux.",
  "2015 is an excellent vintage.",
  "What's the unit price?",
  "NT$8,500 per bottle, 24 bottles in two cases, total NT$204,000.",
  "Is the price negotiable?",
  "We can discuss discounts for larger quantities.",
  "We typically order 4-6 cases per month. Any benefits for long-term partners?",
  "Absolutely, let me apply member pricing for you.",
  "Let's start with this batch then.",
  "No problem.",
  "How soon can it arrive?",
  "It's in stock, delivery within three business days after ordering.",
  "That's fast!",
  "Thank you for your order.",
];

const EN_SCRIPT_3: string[] = [
  "Hello, we're hosting a wedding reception and need wine recommendations.",
  "Hi! How many tables are you expecting?",
  "Thirty tables, about three hundred guests. We'll need red wine and sparkling wine.",
  "Understood.",
  "Any recommendations?",
  "For reds, consider Chateau Lynch-Bages or Caymus. For sparkling, Dom Perignon or Veuve Clicquot are popular choices.",
  "What about the budget?",
  "Overall beverage budget is around NT$180,000.",
  "In that case, a mid-range red + premium champagne combination would work well.",
  "How exactly would that work?",
  "One red per table + two sparkling per table, plus one extra sparkling for the welcome reception.",
  "Sounds comprehensive.",
  "We can also provide on-site sommelier service.",
  "That would be very helpful!",
  "There's an additional fee, but we'll give you a preferential rate.",
  "Please send me a full quotation.",
];

const EN_SCRIPT_4: string[] = [
  "Is this wine in stock?",
  "Yes, it is. How many bottles do you need?",
  "Just one case, I'd like to try it first.",
  "Sure, it's one of our best-sellers.",
  "What's the shipping fee?",
  "Free within Taipei city. NT$300 for other areas.",
  "I'm in Taichung.",
  "Then shipping is NT$300.",
  "Can I pay on delivery?",
  "Yes, and we also accept bank transfers and credit cards.",
  "I'll choose cash on delivery.",
  "No problem.",
  "How long until it arrives?",
  "We'll ship tomorrow, delivery the day after.",
  "That fast?",
  "We have a warehouse in Taichung, so it's quick.",
];

const EN_SCRIPT_5: string[] = [
  "Hi, we're planning a wine tasting event.",
  "Hello! How many attendees are expected?",
  "Around twenty, all senior executives from our company.",
  "Got it. I'd recommend a vertical tasting with five to six wines.",
  "What's a vertical tasting?",
  "It's tasting different vintages from the same winery to compare how aging affects the wine.",
  "That sounds fascinating.",
  "We'll provide tasting notes and a professional instructor.",
  "What's the approximate cost?",
  "Venue + wines + instructor, roughly NT$35,000.",
  "Can we specify the wines?",
  "Of course, we'll curate the wine list based on your budget and preferences.",
  "Let's proceed then.",
  "When would you like to hold it?",
  "End of next month, around the 28th.",
  "Let me check our schedule.",
  "Thanks.",
];

const EN_SCRIPT_6: string[] = [
  "Hi, do you carry Burgundy wines?",
  "Yes, we represent several Burgundy producers.",
  "I'm looking for some Premier Cru level bottles.",
  "Do you have a budget and preferred vintage in mind?",
  "Around NT$4,000-6,000 per bottle, 2018 or 2019 would work.",
  "In that case, I'd recommend a few plots from Chambolle-Musigny and Gevrey-Chambertin.",
  "Sounds lovely. Are they in stock?",
  "Both have less than a case remaining.",
  "Let me order three bottles of each then.",
  "No problem.",
  "If I don't like them after tasting, can I exchange?",
  "We can't accept exchanges after opening, but we'll help with quality issues.",
  "Understood.",
  "I'll hold them for you, please transfer payment today.",
  "Sure, I'll wire it right away.",
];

const EN_SCRIPT_7: string[] = [
  "Hi, Mid-Autumn Festival is coming and we'd like to order some gift sets for clients.",
  "Hello! Mid-Autumn gift sets are one of our popular items. How many do you need?",
  "About eighty sets, budget around NT$2,500 each.",
  "At this budget, we can do one red wine + two cans of premium tea + handmade cookies.",
  "Is there a more upscale option?",
  "We can upgrade to single-vineyard red + top-tier tea + truffle cookies at NT$3,800 per set.",
  "This one, please.",
  "Can the gift box be customized?",
  "Yes, our designer can create exclusive packaging matching your company VI.",
  "Is there a design fee?",
  "Design fee is waived for orders of eighty sets or more.",
  "Excellent.",
  "When do you need delivery?",
  "All delivered before September 10th.",
  "No problem, we'll arrange partial shipments.",
  "Thanks so much.",
];

const EN_SCRIPT_8: string[] = [
  "Hi, there's a problem with the wine I ordered last week.",
  "Hello, what seems to be the issue?",
  "One bottle has a protruding cork, looks like it's gone bad.",
  "We're very sorry, we'll handle this immediately.",
  "Can I get a replacement?",
  "Of course, could you send us a photo for confirmation?",
  "Photo sent.",
  "Received, this is indeed a quality issue.",
  "How soon can it be replaced?",
  "We'll ship the replacement tomorrow at our expense.",
  "Good.",
  "We'll also send an extra bottle of the same vintage as compensation.",
  "That works.",
  "Thank you for your understanding.",
  "No worries.",
];

const EN_SCRIPT_9: string[] = [
  "Hi, our winery is holding a new product launch next month and we'd like to invite your company.",
  "Hello! Which winery is it?",
  "From France's Rhone region, this launch features the 2020 vintage GSM blend.",
  "Sounds interesting. What's the time and venue?",
  "August 15th, at the Regent Hotel Taipei, third floor ballroom.",
  "We have plans that day but should be able to adjust.",
  "The winemaker will be there in person to present.",
  "Wonderful, we'll send our purchasing director.",
  "Shall I reserve seats for you?",
  "Please hold two seats.",
  "Done.",
  "Will there be wines to taste?",
  "We'll have the full series of six wines open for tasting.",
  "Very much looking forward to it.",
  "See you there.",
];

const EN_SCRIPT_10: string[] = [
  "Hi, our company wants to make some custom-label wines as anniversary gifts.",
  "Hello! Custom labels are our specialty. What quantity?",
  "About a hundred bottles, red wine is fine.",
  "Do you already have a label design?",
  "Yes, our design team has the artwork ready.",
  "That's quick. Send us the AI or PDF and we'll send it straight to print.",
  "How long does printing take?",
  "Label printing is five business days, plus three more for labeling and packaging.",
  "Can it be ready by the 5th of next month?",
  "Yes, we have plenty of time.",
  "Any wine recommendations?",
  "For a hundred bottles, Cotes du Rhone offers great value.",
  "Unit price?",
  "Including custom label and packaging, NT$1,200 per bottle.",
  "Works for me.",
  "We'll start preparing then.",
];

const EN_SCRIPT_11: string[] = [
  "Hi, we're an importer and would like to understand the customs process.",
  "Hello! Which country are you importing from?",
  "Mainly France and Italy.",
  "Both are EU regions, so customs documentation requirements are similar.",
  "What documents are needed?",
  "Certificate of origin, sanitary certificate, analysis report, label sample, and import permit.",
  "Can the wineries provide these?",
  "Most can, but the analysis report sometimes requires a separate application.",
  "How long does that take?",
  "Usually two to three weeks, so plan ahead.",
  "What about tax rates?",
  "Wine import duty is 10% of the dutiable value, plus sales tax.",
  "Got it.",
  "We can assist with the full customs clearance process.",
  "Please quote us for that then.",
  "No problem, I'll organize the service items and fees for you.",
];

const EN_SCRIPT_12: string[] = [
  "Hi, do you offer wine cellar rental services?",
  "Yes, we have professional wine cellars of various sizes available for rent.",
  "Our club needs storage for about two hundred bottles.",
  "For two hundred bottles, a 300L dual-zone cellar would work well.",
  "Monthly rental cost?",
  "NT$3,500 per month, including maintenance and temperature monitoring.",
  "Can the temperature be adjusted?",
  "Yes, red wine zone at 12-16°C, white wine zone at 8-12°C.",
  "Humidity?",
  "Built-in humidity system maintains 60-70%.",
  "Sounds very professional.",
  "We also provide regular inspection services.",
  "What's the minimum lease term?",
  "Three months minimum, one month notice required for early termination.",
  "Let me try six months first.",
  "Sure, I'll prepare the contract for you.",
  "Thanks.",
];

const EN_SCRIPT_13: string[] = [
  "Hi, our group is looking to negotiate an annual beverage procurement contract.",
  "Hello! Annual contracts are a key business for us. Estimated annual volume?",
  "About three hundred cases, mostly reds, plus some whites and champagne.",
  "This volume can get excellent pricing.",
  "What's the current partnership price?",
  "Depending on the wine grade, 300 cases annually qualifies for 75-80% of standard pricing.",
  "Payment terms?",
  "Annual contracts typically use net-60 monthly settlement.",
  "Can we sample first?",
  "Of course, we can arrange a tasting event for your team.",
  "When can we start?",
  "We can sign early next month, with first delivery within two weeks after confirming the wine list.",
  "No problem.",
  "Is there price protection during the contract period?",
  "Prices are locked for one year, unaffected by market fluctuations.",
  "That point is very important.",
  "We'll write it into the contract.",
];

const EN_SCRIPT_14: string[] = [
  "Hi, we'd like some wine recommendations for our company year-end party.",
  "Hello! How many people at the year-end party?",
  "About one hundred fifty company-wide.",
  "I'd suggest preparing one red, one white, and one sparkling.",
  "Budget shouldn't be too high, but we want it to look good.",
  "Red: Cotes du Rhone Villages, white: Sancerre, sparkling: Prosecco.",
  "Sounds good. Unit price?",
  "Red NT$680, white NT$620, sparkling NT$450.",
  "Sure.",
  "Do you need corkage service?",
  "No, we have our own staff.",
  "We'll deliver the day before then.",
  "To our company?",
  "Yes, free delivery within Taipei city.",
  "Good.",
  "Date of the party?",
  "January 20th.",
  "Noted.",
];

const EN_SCRIPT_15: string[] = [
  "Hi, we're exhibiting at the Taipei International Wine Show next March and want to discuss partnership.",
  "Hello! We have extensive experience with wine show partnerships. Booth size?",
  "Planning for six booths, around 18 ping.",
  "That's a good size. I'd recommend six to eight featured wines.",
  "We want to focus on Italian wines.",
  "Excellent, Italian wines are trending up in the Taiwan market.",
  "Can we bring winemakers?",
  "Yes, several of our Italian partner wineries are willing to send winemakers.",
  "Who covers airfare and accommodation?",
  "Typically wineries cover airfare, exhibitors handle accommodation.",
  "Understood.",
  "How much tasting wine per day?",
  "Six-day show, six bottles open daily, thirty-six bottles total.",
  "How much inventory should we prepare?",
  "I'd recommend 1.5x, so fifty-four bottles.",
  "Works for us.",
  "We'll start planning the wine list and logistics.",
  "Thank you.",
];

const ZH_SCRIPTS = [ZH_SCRIPT_1, ZH_SCRIPT_2, ZH_SCRIPT_3, ZH_SCRIPT_4, ZH_SCRIPT_5, ZH_SCRIPT_6, ZH_SCRIPT_7, ZH_SCRIPT_8, ZH_SCRIPT_9, ZH_SCRIPT_10, ZH_SCRIPT_11, ZH_SCRIPT_12, ZH_SCRIPT_13, ZH_SCRIPT_14, ZH_SCRIPT_15];
const JA_SCRIPTS = [JA_SCRIPT_1, JA_SCRIPT_2, JA_SCRIPT_3, JA_SCRIPT_4, JA_SCRIPT_5, JA_SCRIPT_6, JA_SCRIPT_7, JA_SCRIPT_8, JA_SCRIPT_9, JA_SCRIPT_10, JA_SCRIPT_11, JA_SCRIPT_12, JA_SCRIPT_13, JA_SCRIPT_14, JA_SCRIPT_15];
const KO_SCRIPTS = [KO_SCRIPT_1, KO_SCRIPT_2, KO_SCRIPT_3, KO_SCRIPT_4, KO_SCRIPT_5, KO_SCRIPT_6, KO_SCRIPT_7, KO_SCRIPT_8, KO_SCRIPT_9, KO_SCRIPT_10, KO_SCRIPT_11, KO_SCRIPT_12, KO_SCRIPT_13, KO_SCRIPT_14, KO_SCRIPT_15];
const EN_SCRIPTS = [EN_SCRIPT_1, EN_SCRIPT_2, EN_SCRIPT_3, EN_SCRIPT_4, EN_SCRIPT_5, EN_SCRIPT_6, EN_SCRIPT_7, EN_SCRIPT_8, EN_SCRIPT_9, EN_SCRIPT_10, EN_SCRIPT_11, EN_SCRIPT_12, EN_SCRIPT_13, EN_SCRIPT_14, EN_SCRIPT_15];

/** 根據客戶 ID 產生穩定的偽隨機數 */
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

/** 根據客戶 ID 和語言，回傳專屬的 15 條模糊訊息文字 */
export function getBlurredTextsForConversation(convId: string, language: string): string[] {
  const lang = language || "zh";
  let scripts: string[][];
  switch (lang) {
    case "ja": scripts = JA_SCRIPTS; break;
    case "ko": scripts = KO_SCRIPTS; break;
    case "en": scripts = EN_SCRIPTS; break;
    default: scripts = ZH_SCRIPTS; break;
  }
  const idx = hashString(convId) % scripts.length;
  return scripts[idx];
}

// 各語言的打字指示器文字
export const TYPING_TEXT: Record<string, string> = {
  zh: "輸入中...",
  ja: "入力中...",
  ko: "입력 중...",
  en: "typing...",
};

// 各語言的客服作業未開放文字
export const CS_UNAVAILABLE_TEXT: Record<string, string> = {
  zh: "客服作業未開放",
  ja: "カスタマーサービス利用不可",
  ko: "고객 서비스 이용 불가",
  en: "Customer Service Unavailable",
};

// 各語言的底部警告文字
export const CS_WARNING_TEXT: Record<string, { title: string; desc: string }> = {
  zh: { title: "客服作業未開放", desc: "新客服部員工或試用期間帳號，無法使用線上客服作業功能。" },
  ja: { title: "カスタマーサービス利用不可", desc: "新入社員または試用期間中のアカウントは、オンラインカスタマーサービス機能をご利用いただけません。" },
  ko: { title: "고객 서비스 이용 불가", desc: "신규 직원 또는 수습 기간 중인 계정은 온라인 고객 서비스 기능을 이용할 수 없습니다." },
  en: { title: "Customer Service Unavailable", desc: "New or trial-period accounts cannot access the online customer service features." },
};

// 各語言的輸入框佔位文字
export const INPUT_PLACEHOLDER: Record<string, string> = {
  zh: "客服作業未開放，無法發送訊息",
  ja: "カスタマーサービス利用不可、メッセージを送信できません",
  ko: "고객 서비스 이용 불가, 메시지를 보낼 수 없습니다",
  en: "Customer service unavailable, cannot send messages",
};

// 各語言的送出按鈕文字
export const SEND_BUTTON_TEXT: Record<string, string> = {
  zh: "送出",
  ja: "送信",
  ko: "전송",
  en: "Send",
};

// 各語言的新訊息預覽池（用於自動置頂模擬）
export const NEW_MESSAGE_PREVIEWS: Record<string, string[]> = {
  zh: [
    "請問這款酒還有庫存嗎？",
    "出貨時間大概多久？",
    "可以開發票嗎？",
    "報價單收到了，謝謝",
    "這批訂單要加購兩箱",
    "請問有試飲活動嗎？",
    "發票資訊需要更改",
    "預計下週到貨嗎？",
    "可否提供酒莊證明？",
    "這個年份還有嗎？",
    "請問有沒有折扣？",
    "想預訂下個月的貨",
    "付款方式有哪些？",
    "訂單 ORD-2047 確認",
    "請問運費怎麼算？",
    "可以安排專人介紹嗎？",
    "需要補開發票",
    "請問最低訂購量？",
    "這款酒適合搭配什麼料理？",
    "想確認訂單進度",
    "請問有會員價嗎？",
    "可以寄試飲樣品嗎？",
    "發票抬頭要修改",
    "這款酒的產區在哪？",
    "請問有現貨嗎？",
  ],
  ja: [
    "このワインの在庫はありますか？",
    "発送までどのくらいかかりますか？",
    "請求書は発行できますか？",
    "お見積りを受け取りました、ありがとうございます",
    "この注文に2ケース追加したいです",
    "試飲会はありますか？",
    "請求書の情報を変更したいです",
    "来週到着予定ですか？",
    "ワイナリーの証明書はいただけますか？",
    "このビンテージはまだありますか？",
    "割引はありますか？",
    "来月分を予約したいです",
    "支払い方法は何がありますか？",
    "注文 ORD-2047 確認",
    "送料はいくらですか？",
    "専任のご案内をお願いできますか？",
    "請求書の再発行が必要です",
    "最低注文数量はいくつですか？",
    "このワインに合う料理は？",
    "注文の進捗を確認したいです",
    "会員価格はありますか？",
    "試飲サンプルを送っていただけますか？",
    "請求書の宛名を変更したいです",
    "このワインの産地はどこですか？",
    "在庫はありますか？",
  ],
  ko: [
    "이 와인 재고 있나요?",
    "배송까지 얼마나 걸리나요?",
    "세금계산서 발급 가능한가요?",
    "견적서 받았습니다, 감사합니다",
    "이 주문에 2박스 추가하고 싶어요",
    "시음회 있나요?",
    "세금계산서 정보 변경하고 싶어요",
    "다음 주 도착 예정인가요?",
    "와이너리 증명서 받을 수 있나요?",
    "이 빈티지 아직 있나요?",
    "할인 있나요?",
    "다음 달 물량 예약하고 싶어요",
    "결제 방법은 어떤 게 있나요?",
    "주문 ORD-2047 확인",
    "배송비는 얼마인가요?",
    "전담 상담 가능한가요?",
    "세금계산서 재발행 필요해요",
    "최소 주문 수량은 얼마인가요?",
    "이 와인에 어울리는 요리는?",
    "주문 진행 상황 확인하고 싶어요",
    "회원 할인가 있나요?",
    "시음 샘플 보내주실 수 있나요?",
    "세금계산서 수신인 변경하고 싶어요",
    "이 와인 산지는 어디인가요?",
    "재고 있나요?",
  ],
  en: [
    "Is this wine still in stock?",
    "How long does shipping take?",
    "Can you issue an invoice?",
    "Received the quotation, thank you",
    "Want to add 2 more cases to this order",
    "Do you have tasting events?",
    "Need to update invoice details",
    "Will it arrive next week?",
    "Can you provide a winery certificate?",
    "Is this vintage still available?",
    "Any discounts available?",
    "Want to pre-order for next month",
    "What payment methods do you accept?",
    "Order ORD-2047 confirmation",
    "How much is the shipping?",
    "Can someone give us a consultation?",
    "Need a reissued invoice",
    "What's the minimum order quantity?",
    "What food pairs well with this wine?",
    "Want to check order status",
    "Do you have member pricing?",
    "Can you send tasting samples?",
    "Need to change invoice title",
    "Where is this wine from?",
    "Is it currently in stock?",
  ],
};

export const onlineAgents = [
  { id: "a1", name: "尹映萱", status: "online", languages: ["中文/英文"] },
  { id: "a2", name: "王俊傑", status: "online", languages: ["中文"] },
  { id: "a3", name: "石子音", status: "online", languages: ["中文/英文"] },
  { id: "a4", name: "余以樂", status: "online", languages: ["中文/英文"] },
  { id: "a5", name: "吳佩珊", status: "online", languages: ["中文"] },
  { id: "a6", name: "吳宜珊", status: "online", languages: ["中文/日文"] },
  { id: "a7", name: "吳宥嫻", status: "online", languages: ["中文"] },
  { id: "a8", name: "李宛蓉", status: "online", languages: ["中文"] },
  { id: "a9", name: "李曉雯", status: "online", languages: ["中文"] },
  { id: "a10", name: "周宏達", status: "online", languages: ["中文/日文"] },
  { id: "a11", name: "周宥廷", status: "online", languages: ["中文"] },
  { id: "a12", name: "孟安琪", status: "online", languages: ["中文/英文"] },
  { id: "a13", name: "林怡萱", status: "online", languages: ["中文"] },
  { id: "a14", name: "邱育誠", status: "online", languages: ["中文/韓文"] },
  { id: "a15", name: "金韻竹", status: "online", languages: ["中文/韓文"] },
  { id: "a16", name: "姚沛樺", status: "online", languages: ["中文/英文"] },
  { id: "a17", name: "倪立群", status: "online", languages: ["中文/日文/韓文"] },
  { id: "a18", name: "秦若哲", status: "online", languages: ["中文/英文"] },
  { id: "a19", name: "馬柏宇", status: "online", languages: ["中文/韓文"] },
  { id: "a20", name: "張雅婷", status: "online", languages: ["中文"] },
  { id: "a21", name: "曾念慈", status: "online", languages: ["中文"] },
  { id: "a22", name: "梁凱倫", status: "online", languages: ["中文/日文/韓文"] },
  { id: "a23", name: "許正恆", status: "online", languages: ["中文/英文"] },
];

export const blurredChatMessages = [
  { id: "m1", isLeft: true, lines: 2, color: "bg-secondary-100" },
  { id: "m2", isLeft: false, lines: 1, color: "bg-primary-100" },
  { id: "m3", isLeft: true, lines: 4, color: "bg-secondary-100" },
  { id: "m4", isLeft: false, lines: 2, color: "bg-primary-100" },
  { id: "m5", isLeft: true, lines: 1, color: "bg-secondary-100" },
  { id: "m6", isLeft: false, lines: 3, color: "bg-primary-100" },
  { id: "m7", isLeft: true, lines: 2, color: "bg-secondary-100" },
  { id: "m8", isLeft: false, lines: 1, color: "bg-primary-100" },
  { id: "m9", isLeft: true, lines: 5, color: "bg-secondary-100" },
  { id: "m10", isLeft: false, lines: 2, color: "bg-primary-100" },
  { id: "m11", isLeft: true, lines: 1, color: "bg-secondary-100" },
  { id: "m12", isLeft: false, lines: 4, color: "bg-primary-100" },
  { id: "m13", isLeft: true, lines: 2, color: "bg-secondary-100" },
  { id: "m14", isLeft: false, lines: 1, color: "bg-primary-100" },
  { id: "m15", isLeft: true, lines: 3, color: "bg-secondary-100" },
];

// 各語言的模糊聊天訊息集（每組 15 條，對應 blurredChatMessages 索引）
// 刻意安排不同長度：短（5-10字）、中（20-35字）、長（50-70字）
export const BLURRED_MESSAGE_TEXTS: Record<string, string[]> = {
  zh: [
    "你好。",
    "您好！請問有什麼可以為您服務的？",
    "我們下週有一場 VIP 晚宴，需要選幾款合適的酒，預算大概每人三千，人數大約五十人，希望有紅酒和白酒各兩款。",
    "好的。",
    "收到。",
    "了解，那我推薦這幾款：Chateau Margaux、Opus One 和 Sassicaia，另外白酒可以考慮 Montrachet 和 Puligny-Montrachet。",
    "聽起來不錯，可以先給我看報價單嗎？",
    "沒問題，我馬上整理給您。",
    "另外請問有提供品酒服務嗎？我們這邊有一些賓客對酒比較陌生，可能需要專人在場介紹每款酒的產區、風味和搭配建議，這樣晚宴體驗會更好。",
    "有的。",
    "太好了。",
    "請問需要什麼時候確認呢？因為下週二就要開始佈置場地了。",
    "這個週五前可以嗎？",
    "可以的，我盡快處理，報價單會在今天下班前寄給您。",
    "好的。",
  ],
  ja: [
    "こんにちは。",
    "はい、どのようなご用件でしょうか？",
    "来週VIPディナーがあるので、適したワインを選びたいです。約50名で、お一人様NT$3,000程度、赤白各2本ずつご提案いただけますでしょうか。",
    "かしこまりました。",
    "承知しました。",
    "シャトー・マルゴー、オーパスワン、サッシカイアをお勧めします。白ワインではモンラッシェとプリニー・モンラッシェが良いかと思います。",
    "良さそうですね。見積書をいただけますか？",
    "はい、すぐにご用意いたします。",
    "テイスティングサービスはありますか？一部のゲストはワインに詳しくないので、産地や風味、ペアリングのご説明を専任スタッフにお願いしたいのですが。",
    "ございます。",
    "素晴らしいです。",
    "いつまでにご確認いただけますか？来週火曜日には会場の準備を始めますので。",
    "今週の金曜日までにお願いできますか？",
    "承知しました、早急に対応いたします。本日中にお見積りをメールでお送りします。",
    "よろしくお願いします。",
  ],
  ko: [
    "안녕하세요.",
    "안녕하세요! 무엇을 도와드릴까요?",
    "다음 주 VIP 만찬이 있어서 적합한 와인을 고르고 싶습니다. 약 50명, 1인당 NT$3,000 정도 예산이고, 레드와인과 화이트와인 각각 2종류씩 추천해 주실 수 있나요?",
    "네, 알겠습니다.",
    "네.",
    "샤토 마고, 오퍼스 원, 사시카이아를 추천드립니다. 화이트와인은 몽라셰와 풀리니 몽라셰를 고려해 보세요.",
    "좋네요. 견적서 먼저 보내주실 수 있나요?",
    "네, 바로 준비해드리겠습니다.",
    "테이스팅 서비스도 있나요? 일부 손님들은 와인을 잘 모르셔서, 전담 직원이 산지와 풍미, 페어링을 설명해 주시면 좋겠습니다.",
    "네, 있습니다.",
    "좋습니다.",
    "언제까지 확인하면 될까요? 다음 주 화요일부터 장소 준비를 시작해야 해서요.",
    "이번 주 금요일까지 가능할까요?",
    "네, 최대한 빨리 처리하겠습니다. 오늘 중으로 견적서를 메일로 보내드리겠습니다.",
    "연락 기다리겠습니다.",
  ],
  en: [
    "Hi.",
    "Hello! How can I assist you today?",
    "We have a VIP dinner next week and need to select some suitable wines. Around 50 people, budget about NT$3,000 per person. Can you recommend two reds and two whites?",
    "Sure.",
    "Got it.",
    "I'd recommend Chateau Margaux, Opus One, and Sassicaia. For whites, Montrachet and Puligny-Montrachet would be excellent choices.",
    "Sounds great. Can you send me the quotation first?",
    "Sure, I'll prepare it right away.",
    "Also, do you offer tasting services? Some of our guests aren't familiar with wines, so we'd appreciate having a specialist explain the regions, flavor profiles, and pairing suggestions during the dinner.",
    "Yes, we do.",
    "Wonderful.",
    "When would you need confirmation? We need to start venue setup by next Tuesday.",
    "By this Friday, is that possible?",
    "Absolutely, I'll expedite it. You'll receive the quotation via email before end of business today.",
    "Thanks, looking forward to it.",
  ],
};